import styled from "@emotion/styled";
import { ReactComponent as TransparentLogo } from "../assets/backgroundMSLogo.svg";
import Header from "../pages/Header.js/Header";
import MSLogo from "../assets/msLogo.png";
import { Typography } from "@mui/material";

const BackgroundGradient = ({
  children,
  containerStyle,
  color = "#cccccc",
}) => (
  <StyledBackground color={color}>
    <div className="page-wrapper">
      <Header />
      <div className="children-wrapper" style={containerStyle}>
        {children}
      </div>
    </div>
    <div className="background-logo-wrapper">
      <TransparentLogo className="background-logo" />
    </div>
  </StyledBackground>
);

const StyledBackground = styled.div`
  height: 100vh;
  max-height: 100vh;
  width: 100%;
  max-width: 100vw;
  position: absolute;

  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;

  .background-logo-wrapper {
    height: 100%;
    width: 100%;
    max-width: 100vw;
    position: absolute;
    display: flex;
    justify-content: center;
    overflow: hidden;
    z-index: -100;

    background: -webkit-linear-gradient(${(props) => props.color}, #fff);
    background: -moz-linear-gradient(${(props) => props.color}, #fff);
    background: -ms-linear-gradient(${(props) => props.color}, #fff);
    background: -o-linear-gradient(${(props) => props.color}, #fff);
    background: linear-gradient(${(props) => props.color}, #fff);
  }

  .background-logo {
    min-width: 1036px;
    width: 90%;
    min-height: 933px;
    aspect-ratio: 0.9;
  }

  .page-wrapper {
    position: absolute;
    width: 100%;
    max-width: 100vw;
    min-height: 100vh;
    overflow-y: auto;
    top: 0;
  }

  .children-wrapper {
    display: flex;
    justify-content: center;
    width: 100%;
    max-width: 100vw;
  }
`;

export default BackgroundGradient;
